import { defineComponent as _defineComponent } from 'vue'
import Vue, { computed } from 'vue';

import HiddenHorizontalScrollbar from '@/components/HiddenHorizontalScrollbar.vue';
import { TitleDetail } from '@/interfaces/title-details-graphql';
import { SnowplowContext, SnowplowTitleContextGraphql } from '@/helpers/tracking/providers';
import { ThumborOptions } from '@/filters/thumbor';
import TitleDetailLink from '@/components/nav/links/TitleDetailLink.vue';
import PictureComp from '@/components/picture/PictureComp.vue';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import { ObjectType } from '@/@types/graphql-types';

interface SeasonsListProps {
	title: TitleDetail & { __typename: 'Show' };
	additionalContexts: SnowplowContext[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SeasonListV1',
  props: {
    title: null,
    additionalContexts: { default: () => [] }
  },
  setup(__props: any) {

const props = __props as { title: TitleDetail & { __typename: 'Show' }, additionalContexts: SnowplowContext[] };



const seasons = computed(() => props.title.seasons ?? []);

function getTitleSlug(fullPath: string) {
	const slug = fullPath?.match(/([^\/]*)$/);
	return slug?.[0] ?? 'Poster';
}

function getImageUrl(posterUrl: string | undefined) {
	return Vue.filter('Thumbor')({ url: posterUrl, imageType: 'poster' } as ThumborOptions);
}

function trackSeasonTitleClicked(title: (TitleDetail & { __typename: 'Show' })['seasons'][0], index: number) {
	TrackingHelper.trackEvent(
		'userinteraction',
		{ action: 'title_clicked', label: `${title.content.seasonNumber}`, property: 'season', value: index },
		[
			new SnowplowTitleContextGraphql(title?.show?.objectId, ObjectType.Show, title.content.seasonNumber),
			...props.additionalContexts,
		]
	);
}

return { __sfc: true,props, seasons, getTitleSlug, getImageUrl, trackSeasonTitleClicked, HiddenHorizontalScrollbar, TitleDetailLink, PictureComp }
}

})